import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import useUserData from 'contexts/UserContext/hooks/useUserData';
import useAPIRequest from 'hooks/useAPIRequest';
import useUserByUID from 'hooks/useUserByUID';

import IntercomWithUserAndCompany from './IntercomWithUserAndCompany';
import bootIntercom from './helpers/bootIntercom';
import createUserAttributes from './helpers/createUserAttributes';

const IntercomWithUser = ({ userDataAuth = {} }) => {
  const { userDoc: userDataFirestore } = useUserByUID();
  const userClaims = useUserData();

  const [userHash, setUserHash] = useState(null);

  const { fetchData: ensureUserIntercomHash } = useAPIRequest({
    method: 'PUT',
    service: 'UCD',
  });

  const userAttributes = useMemo(
    () =>
      createUserAttributes({
        userDataAuth,
        userDataFirestore,
        userClaims,
        userHash,
      }),
    [userDataAuth, userDataFirestore, userClaims, userHash]
  );

  const shouldTrackOnlyUserAttributes =
    userClaims.isAnonymous ||
    userClaims.claimsAdmin ||
    userClaims.claimsAgencyId;

  useEffect(() => {
    const generateUserHash = async () => {
      const { hash } = await ensureUserIntercomHash({
        endpoint: `/users/${userDataAuth.uid}/hash`,
      });
      setUserHash(hash);
    };
    generateUserHash();
  }, [
    ensureUserIntercomHash,
    userDataAuth.uid,
    userDataFirestore.intercomUserHash,
  ]);

  useEffect(() => {
    if (shouldTrackOnlyUserAttributes && userAttributes) {
      bootIntercom(userAttributes);
    }
  }, [shouldTrackOnlyUserAttributes, userAttributes, userHash]);

  if (shouldTrackOnlyUserAttributes || !userAttributes) {
    return null;
  }

  return <IntercomWithUserAndCompany userAttributes={userAttributes} />;
};

IntercomWithUser.propTypes = {
  userDataAuth: PropTypes.object,
};

export default IntercomWithUser;
